<template>
  <div class="fillcontain">
    <search-item
      @showDialog="showAddShowDialog"
      @searchList="getShowList"
      @changePageAndLimit="handleChangePageAndLimit"
    ></search-item>
    <div class="table_container">
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        border
        align="center"
        @select="selectTable"
        @select-all="selectAll"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          width="50"
          prop="id"
          label="序号"
          v-if="false"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="isShow"
          label="是否展示在小程序"
          align="left"
          :filters="fields.isShow.filter.list"
          :filter-method="filterIsShow"
          filter-placement="bottom-end"
        >
          <template slot-scope="scope">
            <el-tag
              v-html="formatterIsShow(scope.row)"
              :type="scope.row.isShow === 0 ? 'warning' : 'success'"
              disable-transitions
              >{{ scope.row.isShow }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column prop="operation" align="center" label="操作" fit>
          <template slot-scope="scope">
            <el-button
              type="warning"
              icon="edit"
              size="mini"
              @click="onEditStudent(scope.row)"
              >编辑</el-button
            >
            <el-button
              v-show="ROLE == 1"
              type="danger"
              icon="delete"
              size="mini"
              @click="onDeleteCoach(scope.row, scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :pageTotal="pageTotal"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      ></pagination>
      <addFundDialog
        v-if="addShowDialog.show"
        :isShow="addShowDialog.show"
        :dialogRow="addShowDialog.dialogRow"
        @getShowList="getShowList"
        @closeDialog="hideAddFundDialog"
      ></addFundDialog>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import SearchItem from "./components/searchItem";
import AddFundDialog from "./components/addCoachDialog";
import Pagination from "@/components/pagination";
import { getToken } from "@/utils/auth";
import { getShowList, deleteActiontype } from "@/api/show";
import { addOperationRecord } from "@/api/operationrecord";

export default {
  data() {
    return {
      tableData: [],
      tableHeight: 0,
      loading: false,
      idFlag: false,
      isShow: false, // 是否显示资金modal,默认为false
      editid: "",
      ROLE: 0,
      multipleSelection: [], //多选的数据
      sortnum: 0,
      addShowDialog: {
        show: false,
        dialogRow: {},
      },
      showData: {
        page: 1,
        limit: 20,
      },
      format_isshow_list: {
        0: "否",
        1: "是",
      },
      fields: {
        isShow: {
          filter: {
            list: [
              {
                text: "否",
                value: 0,
              },
              {
                text: "是",
                value: 1,
              },
            ],
          },
        },
      },
      pageTotal: 0,
    };
  },
  components: {
    SearchItem,
    AddFundDialog,
    Pagination,
  },
  computed: {
    ...mapGetters(["coachSearch"]),
  },
  created() {
    this.ROLE = getToken("ROLE");
  },
  mounted() {
    this.getShowList();
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableHeight = document.body.clientHeight - 300;
      });
    },
    filterIsShow(value, item) {
      const type = parseInt(item.isShow);
      return this.format_isshow_list[value] == this.format_isshow_list[type];
    },
    /**
     * 格式化状态
     */
    formatterIsShow(item) {
      const type = parseInt(item.isShow);
      //   console.log(item.isShow);
      return this.format_isshow_list[type];
    },
    getShowList() {
      const para = Object.assign({}, this.showData);
      getShowList(para).then((res) => {
        console.log(res);
        this.loading = false;
        this.pageTotal = res.data.data.total;
        this.tableData = res.data.data.showlist;
      });
    },
    // 显示资金弹框
    showAddShowDialog(val) {
      this.$store.commit("SET_SHOW_DIALOG_TITLE", val);
      this.addShowDialog.show = true;
    },
    hideAddFundDialog() {
      this.addShowDialog.show = false;
    },
    // 上下分页
    handleCurrentChange(val) {
      this.showData.page = val;
      this.getShowList();
    },
    handleChangePageAndLimit() {
      this.showData.page = 1;
      this.showData.limit = 20;
    },
    // 每页显示多少条
    handleSizeChange(val) {
      this.showData.limit = val;
      this.getShowList();
    },
    // 编辑操作方法
    onEditStudent(row) {
      console.log(row);
      this.addShowDialog.dialogRow = { ...row };
      this.showAddShowDialog();
    },
    // 删除数据
    onDeleteCoach(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const para = { id: row.id };
          console.log(para);
          deleteActiontype(para).then((res) => {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            const para = {
              userName: getToken("USERNAME"),
              content: "删除(" + row.name + ")展示栏目操作",
            };
            addOperationRecord(para).then((res) => {
              console.log(res);
            });
            this.getShowList();
          });
        })
        .catch(() => {});
    },
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    selectTable(val, row) {
      this.setSearchBtn(val);
    },
    // 用户全选checkbox时触发该事件
    selectAll(val) {
      this.setSearchBtn(val);
    },
    setSearchBtn(val) {
      let isFlag = true;
      if (val.length > 0) {
        isFlag = false;
      } else {
        isFlag = true;
      }
      this.$store.commit("SET_COACH_SEARCHBTN_DISABLED", isFlag);
    },
  },
};
</script>


<style lang="less" scoped>
.table_container {
  padding: 10px;
  background: #fff;
  border-radius: 2px;
  overflow: auto;
}
.el-dialog--small {
  width: 600px !important;
}
.pagination {
  text-align: left;
  margin-top: 10px;
}
.picture {
  width: 100px;
  height: 100px;
}
</style>